module.exports = __webpack_public_path__ + "static/ourwork-tradeshows-934f43f86badec18cf58b5475376b763.jpg";